import React, { useEffect, useRef } from "react";
import { Box, Flex } from "@chakra-ui/react";
import { Outlet, useLocation } from "react-router-dom";
import { Header, MobileSidebar, Sidebar } from "./components";
import styles from "./Layout.module.css";

const AppLayout: React.FC = () => {
  const contentRef = useRef<HTMLDivElement>(null);
  const { pathname } = useLocation();
  const [navSize, setNavSize] = React.useState<"sm" | "lg">("lg");

  useEffect(() => {
    contentRef?.current?.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Flex h="100vh" backgroundColor="gray.50">
      <Sidebar
        navSize={navSize}
        setNavSize={setNavSize}
        display={{ base: "none", lg: "flex" }}
      />
      <MobileSidebar display={{ base: "flex", lg: "none" }} />
      <Flex
        id="content-wrapper"
        flex="1"
        flexDirection="column"
        overflow="auto"
        ref={contentRef}
        className={styles.content}
      >
        <Header navSize={navSize} />
        <Box
          as="main"
          w="full"
          px={{ base: "6", lg: "16" }}
          py={6}
          maxW="1552px" // 1488+ 2*32px padding
        >
          <React.Suspense fallback={null}>
            <Outlet />
          </React.Suspense>
        </Box>
      </Flex>
    </Flex>
  );
};

export default AppLayout;
